import {useCallback, useEffect, useRef, useState} from 'react'

export const AKTUALISIERUNG_INTERVALL_MS = 30 * 1000;
// danach wird nicht mehr automatisch geladen, damit vergessene Fenster das Backend nicht dauerhaft abfragen
export const AKTUALISIERUNG_MAX_DAUER_MS = 60 * 60 * 1000;

/**
 * Lädt regelmäßig neu, solange die Seite sichtbar ist, höchstens eine Stunde lang.
 * Ist der Tab im Hintergrund, wird pausiert und beim Zurückkehren sofort geladen.
 *
 * @param laden Funktion (onErfolg) => void, onErfolg nach erfolgreichem Laden aufrufen
 * @returns {aktiv, zuletzt, markiereGeladen, jetztLaden, wiederEinschalten}
 */
export default function useAutoAktualisierung(laden) {

    // immer die aktuelle Funktion verwenden, ohne den Timer bei jedem Rendern neu aufzusetzen
    const ladenRef = useRef(laden);
    ladenRef.current = laden;

    const [start, setStart] = useState(() => Date.now());
    const [aktiv, setAktiv] = useState(true);
    const [zuletzt, setZuletzt] = useState(undefined);

    const markiereGeladen = useCallback(() => setZuletzt(Date.now()), []);

    const jetztLaden = useCallback(() => {
        ladenRef.current(markiereGeladen);
    }, [markiereGeladen]);

    useEffect(() => {
        if (!aktiv) {
            return;
        }
        const ende = start + AKTUALISIERUNG_MAX_DAUER_MS;
        let timer;

        const beenden = () => {
            if (Date.now() < ende) {
                return false;
            }
            setAktiv(false);
            return true;
        }

        const plane = () => {
            clearInterval(timer);
            if (document.visibilityState === "hidden") {
                return;
            }
            timer = setInterval(() => {
                if (!beenden()) {
                    jetztLaden();
                }
            }, AKTUALISIERUNG_INTERVALL_MS);
        }

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && !beenden()) {
                jetztLaden();
            }
            plane();
        }

        plane();
        // zum Ende der Stunde abschalten, auch wenn der Tab gerade im Hintergrund ist
        const endeTimer = setTimeout(() => setAktiv(false), Math.max(0, ende - Date.now()));
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            clearInterval(timer);
            clearTimeout(endeTimer);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [aktiv, start, jetztLaden]);

    const wiederEinschalten = () => {
        setStart(Date.now());
        setAktiv(true);
        jetztLaden();
    }

    return {aktiv, zuletzt, markiereGeladen, jetztLaden, wiederEinschalten};
}
